import { ComplaintRequest, ComplaintResponse } from 'types/complaints';
import { COMPLAINTS } from 'utils/constants/end-points';
import Http from './http';

class ComplaintsService {
	reportComplaint = (data: ComplaintRequest): Promise<ComplaintResponse> => Http.post(COMPLAINTS, data );
}

export default new ComplaintsService();
